import React, { useEffect, useState } from "react";
import { allCompanies } from "../../../api/admin/companyApi";
import { FcApproval } from "react-icons/fc";

const CompanySelect = ({ setCompanyId, CompanyId }) => {
  const [Data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [Show, setShow] = useState(false);
  const [Search, setSearch] = useState("");
  const [SelectedCompany, setSelectedCompany] = useState("");
  useEffect(() => {
    allCompanies(setData);
  }, []);
  const handleShow = () => {
    setShow(!Show);
  };
  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(Data);
    }
    const result = Data.filter((item) =>
      item.companyName.toLowerCase().includes(Search.toLowerCase())
    );
    setFilteredData(result);

    if (CompanyId) {
      const filterDataByCompanyId = Data.filter(
        (item) => item.id === CompanyId
      );
      setSelectedCompany(filterDataByCompanyId[0]);
    }
  }, [Search, Data, CompanyId]);
  const handleSelect = (item) => {
    setSelectedCompany(item);
    setCompanyId(item.id);
    setShow(false);
  };
  return (
    <div className="w-full relative">
      <div
        onClick={handleShow}
        className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm cursor-pointer select-none flex justify-start items-center gap-3"
      >
        {SelectedCompany ? (
          <>
            <div className="w-10 h-5 overflow-hidden rounded-sm">
              <img
                className="w-full h-full object-cover"
                src={SelectedCompany.companyLogo}
                alt=""
              />
            </div>
            <div className="flex gap-x-2 justify-start items-center">
              <p className="text-sm font-medium uppercase">
                {SelectedCompany.companyName}
              </p>
              <span>
                <FcApproval className="text-md" />
              </span>
            </div>
          </>
        ) : (
          <div>
            <p>Select company</p>
          </div>
        )}
      </div>
      {Show && (
        <div className="bg-white w-full max-h-[300px] overflow-y-auto p-3 absolute top-10 drop-shadow-lg left-1/2 -translate-x-1/2 rounded-lg z-10 border scrollbar-hide">
          <div className="space-y-3">
            <div>
              <input
                type="text"
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                placeholder="Search company by name"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
              />
            </div>
            <div>
              {filteredData.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => handleSelect(item)}
                    className="flex gap-2 justify-start items-center bg-white hover:bg-[#d7eaff] p-2 rounded-lg cursor-pointer"
                  >
                    <div className="w-10 h-5 overflow-hidden rounded-sm">
                      <img
                        className="w-full h-full object-cover"
                        src={item.companyLogo}
                        alt=""
                      />
                    </div>
                    <div className="flex gap-x-2 justify-start items-center">
                      <p className="text-sm font-medium uppercase">
                        {item.companyName}
                      </p>
                      <span>
                        <FcApproval className="text-md" />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanySelect;
